/**
 * Gaya react-select untuk pemilih jumlah baris ("Show : N") di halaman daftar:
 * /katalog-lagu, /pencipta, /admin, /pendapatan, /distribusi.
 *
 * Sebelumnya tiap halaman punya salinan `customStylesFilter` sendiri — lima
 * salinan yang isinya sudah mulai berbeda satu sama lain. Nilainya di sini
 * sama persis dengan salinan-salinan itu; yang berubah hanya tempatnya, jadi
 * sekarang cukup diubah di satu berkas.
 */
export const TOOLBAR_SELECT_STYLES = {
  control: (provided) => ({
    ...provided,
    minHeight: "30px",
    height: "30px",
    width: "75px",
  }),

  valueContainer: (provided) => ({
    ...provided,
    height: "30px",
    width: "75px",
    padding: "0px",
  }),

  singleValue: (provided) => ({
    ...provided,
    textAlign: "center",
  }),

  input: (provided) => ({
    ...provided,
    margin: "0px",
    padding: "0px",
  }),

  indicatorSeparator: () => ({
    display: "none",
  }),

  indicatorsContainer: (provided) => ({
    ...provided,
    height: "30px",
  }),
};
